// utils/axiosInstance.js or wherever your axios setup is
import axios from 'axios';
import baseURL from '../config.js';

const axiosInstance = axios.create({
  baseURL,
});

// ✅ Add interceptor to attach token dynamically for every request
axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default axiosInstance;
